import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const KEY = "ps_cookie_consent";
const LEGAL_PATHS = ["/privacy", "/cookie", "/termini"];

export const CookieBanner = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  const { pathname } = useLocation();
  if (choice || LEGAL_PATHS.includes(pathname)) return null;

  const decide = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, privacy_accepted: true, date: new Date().toISOString() }));
    setChoice(value);
  };

  return (
    <div data-testid="cookie-banner" className="fixed inset-0 z-[70] flex items-end md:items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div className="w-full max-w-lg border border-[#C9A227]/30 bg-[#0b0b0d] rounded-sm p-6 shadow-2xl">
        <div className="flex items-center gap-2 text-[#C9A227]">
          <ShieldCheck size={18} />
          <span className="text-xs font-mono-ps uppercase tracking-widest">Privacy & Cookie</span>
        </div>
        <h3 className="font-display text-xl font-bold text-white mt-3">Benvenuto su PULL STATION</h3>
        <p className="text-sm text-white/80 mt-2 leading-relaxed">
          Per continuare ti chiediamo di prendere visione della nostra{" "}
          <Link to="/privacy" data-testid="consent-privacy-link" className="text-[#C9A227] underline underline-offset-2">Privacy Policy</Link>.
          Usiamo solo cookie tecnici necessari (login, carrello); eventuali cookie non essenziali verranno attivati solo con il tuo consenso.{" "}
          <Link to="/cookie" data-testid="cookie-banner-policy" className="text-[#C9A227] underline underline-offset-2">Cookie Policy</Link>
        </p>
        <div className="mt-5 flex flex-col sm:flex-row gap-2">
          <button onClick={() => decide("necessary")} data-testid="cookie-reject" className="flex-1 px-4 py-2.5 text-sm border border-[#C9A227]/40 text-white hover:border-[#C9A227] rounded-sm transition-colors">
            Accetto, solo cookie necessari
          </button>
          <button onClick={() => decide("all")} data-testid="cookie-accept" className="btn-gold flex-1 justify-center">
            Accetto tutto
          </button>
        </div>
      </div>
    </div>
  );
};
